export default "__VITE_ASSET__IJP3QwXS__"